/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Culture_PlaceholderInputs */

const en_candidate_profile_culture_placeholder = /** @type {(inputs: Candidate_Profile_Culture_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Collaborative, Innovative`)
};

const de_candidate_profile_culture_placeholder = /** @type {(inputs: Candidate_Profile_Culture_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Kollaborativ, Innovativ`)
};

/**
* | output |
* | --- |
* | "e.g., Collaborative, Innovative" |
*
* @param {Candidate_Profile_Culture_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_culture_placeholder = /** @type {((inputs?: Candidate_Profile_Culture_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Culture_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_culture_placeholder(inputs)
	return en_candidate_profile_culture_placeholder(inputs)
});